<template>
    <nav class="header__sections" :class="{ 'header__sections--admin': isAdmin }">
        <ul class="header__sections--list-wrapper" itemscope itemtype="https://schema.org/SiteNavigationElement">
            <div>
                <li>
                    <el-popover placement="bottom-start" width="259" trigger="hover" popper-class="popoverCastom"
                        :offset="30">
                        <template><header-pages :render="render" :pages="sections[4].pages"></header-pages></template>
                        <template #reference>
                            <div class="header__burger-menu-container" @mouseenter="hovered = true"
                                @mouseleave="hovered = false">
                                <svg v-if="hovered" width="21" height="8">
                                    <use :href="'/assets/front/img/sprite.svg#icon-burgerseparator'"></use>
                                </svg>
                                <svg v-else="section.isShowIcon" width="21" height="8">
                                    <use :href="'/assets/front/img/sprite.svg#icon-burgerseparatorblack'"></use>
                                </svg>
                            </div>
                        </template>
                    </el-popover>
                </li>
            </div>
            <div class="header__sections-list">
                <li v-for="(section, index) in sections" :key="index" v-if="!section.isBurgerMenu"
                    class="header__section" :class="{
                        active: section.active,
                        'header__section-list--active': section.active,
                    }">
                    <el-popover placement="bottom" width="259" trigger="hover" :offset="30"
                        :disabled="lodash.isEmpty(section.pages)">
                        <template>
                            <header-pages :render="render" :pages="section.pages"></header-pages>
                        </template>
                        <template #reference>
                            <a class="header__section-name-wrapper header__section-name--icon"
                                :class="{ 'header__section-name--active': section.active }" :href="section.href"
                                itemprop="url">
                                <svg v-if="section.isShowIcon" class="header__section-name--icon" width="21" height="21"
                                    :class="{ 'header__section-name--active': section.active }">
                                    <use :href="'/assets/front/img/sprite.svg#' + section.icon"></use>
                                </svg>
                                <p class="header__section-name" @click="redirect(section.href)">
                                    {{ section.name }}
                                </p>
                                <svg v-if="section.isShowIcon" width="10" height="10">
                                    <use xlink:href="/assets/front/img/sprite.svg#icon-caret-b"></use>
                                </svg>
                            </a>
                        </template>
                    </el-popover>
                </li>
            </div>

        </ul>
    </nav>
</template>

<script>
import HeaderProfile from "./HeaderProfile.vue";
import HeaderPages from "./HeaderPages.vue";

const lodash = require('lodash');

export default {
    name: 'HeaderSections',
    data() {
        return {
            hovered: false,
            lodash: lodash,
        }
    },
    components: { HeaderProfile, HeaderPages },
    props: ['sections', 'render', 'isAdmin'],
    methods: {
        redirect(href) {
            return location.href = window.laravel.appUrlByLocale + window.laravel.prefix + href;
        }
    }
}

</script>
